<template>
  <div v-if="isLoading" class="loading-page">
    <img
      src="@/assets/image/Well_Line02_.gif"
      alt="Loading"
      class=""
      style="
        width: 120%;
        margin-left: -20px;
        height: 120%;
        object-fit: cover;
        overflow: hidden;
      "
    />
    <div class="body-max-width description">
      <p class="flex-mid header">{{ $t("inProgress") }}</p>
      <p class="flex-mid detail">{{ $t("inProgressMessage") }}</p>
      <p class="flex-mid detail">{{ $t("inProgressMessage2") }}</p>
    </div>
  </div>
  <div v-else>
    <div class="assessment-report">
      <div class="mt-36 mb-36 fs-16 fw-500 flex-mid">
        {{ $t("RiskAssessment") }}
      </div>

      <div v-if="riskData.length == 0" class="no-suggest-package">
        <div class="center">
          <div class="mt-10">
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_12811_16937)">
                <path
                  d="M25 42C36.598 42 46 32.598 46 21C46 9.40202 36.598 0 25 0C13.402 0 4 9.40202 4 21C4 32.598 13.402 42 25 42Z"
                  fill="white"
                />
                <path
                  d="M24.9995 38.9492C34.9128 38.9492 42.9492 30.9128 42.9492 20.9995C42.9492 11.0862 34.9128 3.0498 24.9995 3.0498C15.0862 3.0498 7.0498 11.0862 7.0498 20.9995C7.0498 30.9128 15.0862 38.9492 24.9995 38.9492Z"
                  fill="#89C980"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.1486 22.4803C19.2989 22.3016 19.5206 22.1984 19.7542 22.1984H31.0177C31.2451 22.1984 31.4615 22.2962 31.6117 22.4669C31.7619 22.6376 31.8315 22.8647 31.8026 23.0902L31.0177 22.9896C31.8026 23.0902 31.8025 23.0908 31.8024 23.0913L31.8023 23.0925L31.8019 23.0951L31.8011 23.1013L31.7986 23.1182C31.7967 23.1313 31.794 23.1482 31.7905 23.1685C31.7834 23.2092 31.7729 23.2638 31.7579 23.3306C31.7279 23.4638 31.6794 23.6463 31.6031 23.8617C31.4508 24.2913 31.1842 24.861 30.724 25.4311C29.7794 26.6013 28.1019 27.6699 25.2376 27.6699V26.8787C25.2376 27.6699 25.2372 27.6699 25.2369 27.6699L25.2361 27.6699L25.2342 27.6699L25.229 27.6699L25.2135 27.6697C25.2008 27.6696 25.1836 27.6693 25.1622 27.6687C25.1193 27.6675 25.0594 27.6653 24.9845 27.661C24.835 27.6525 24.625 27.6356 24.3726 27.6024C23.8707 27.5363 23.1858 27.4033 22.4698 27.1327C21.0366 26.591 19.3787 25.4481 18.9746 23.1252C18.9346 22.8951 18.9983 22.6591 19.1486 22.4803Z"
                  fill="#592727"
                />
                <path
                  d="M16.7665 19.0894C17.658 19.0894 18.3807 18.3667 18.3807 17.4753C18.3807 16.5838 17.658 15.8611 16.7665 15.8611C15.875 15.8611 15.1523 16.5838 15.1523 17.4753C15.1523 18.3667 15.875 19.0894 16.7665 19.0894Z"
                  fill="#592727"
                />
                <path
                  d="M33.2489 19.0894C34.1404 19.0894 34.8631 18.3667 34.8631 17.4753C34.8631 16.5838 34.1404 15.8611 33.2489 15.8611C32.3575 15.8611 31.6348 16.5838 31.6348 17.4753C31.6348 18.3667 32.3575 19.0894 33.2489 19.0894Z"
                  fill="#592727"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_12811_16937"
                  x="0"
                  y="0"
                  width="50"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_12811_16937"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_12811_16937"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div class="fs-14 fw-500">{{ $t("noRisk") }}</div>
        </div>
        <div class="text p-10 mt-10">
          <p class="fs-12 fw-500">{{ $t("suggest") }}</p>

          <div
            v-if="!is19To50"
            class="fs-11"
            v-html="$t('nothaverisksuggest')"
          ></div>
          <div v-else class="fs-11" v-html="$t('nothaverisksuggest2')"></div>
        </div>
      </div>
      <div v-else>
        <div
          v-for="value in riskData"
          :key="value.riskId"
          class="report-card center mt-18"
        >
          <div class="card-header fs-16 fw-500 fc-020202">
            <div class="icon">
              <div class="icon-background">
                <img
                  v-if="value.riskId == 1"
                  src="@/assets/image/NewDesign/IconDisease/cardiovascular.png"
                  style="width: 4rem"
                />
                <img
                  v-else-if="value.riskId == 2"
                  src="@/assets/image/NewDesign/IconDisease/diabetes.png"
                  style="width: 4rem"
                />
                <img
                  v-else-if="value.riskId == 3"
                  src="@/assets/image/NewDesign/IconDisease/coloncancer.png"
                  style="width: 4rem"
                />
                <img
                  v-else-if="value.riskId == 4"
                  src="@/assets/image/NewDesign/IconDisease/stroke.png"
                  style="width: 4rem"
                />
                <img
                  v-else-if="value.riskId == 5"
                  src="@/assets/image/NewDesign/IconDisease/metabolic.png"
                  style="width: 4rem"
                />
                <img
                  v-else-if="value.riskId == 6"
                  src="@/assets/image/NewDesign/IconDisease/lungcancer.png"
                  style="width: 4rem"
                />
              </div>
            </div>
            <p class="risk-name">
              {{ value.riskName }}
            </p>
            <hr />
          </div>

          <div v-if="lang == 'th'" class="risklevel">
            <div v-if="value.maxSeverityLevel == 3">
              <div v-if="value.severity == 3">
                <img
                  src="@/assets/image/NewDesign/level/high-risk.png"
                  style="width: 80%"
                />
              </div>
              <div v-else-if="value.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/medium-risk.png"
                  style="width: 80%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk.png"
                  style="width: 80%"
                />
              </div>
            </div>
            <div v-else>
              <div v-if="value.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/high-risk.png"
                  style="width: 80%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk.png"
                  style="width: 80%"
                />
              </div>
            </div>
          </div>
          <div v-else class="risklevel">
            <div v-if="value.maxSeverityLevel == 3">
              <div v-if="value.severity == 3">
                <img
                  src="@/assets/image/NewDesign/level/high-risk-en.png"
                  style="width: 80%"
                />
              </div>
              <div v-else-if="value.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/medium-risk-en.png"
                  style="width: 80%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk-en.png"
                  style="width: 80%"
                />
              </div>
            </div>
            <div v-else>
              <div v-if="value.severity == 2">
                <img
                  src="@/assets/image/NewDesign/level/high-risk-en.png"
                  style="width: 80%"
                />
              </div>
              <div v-else>
                <img
                  src="@/assets/image/NewDesign/level/low-risk-en.png"
                  style="width: 80%"
                />
              </div>
            </div>
          </div>

          <div class="card-description">
            <p class="your-risk-assessment">
              {{ $t("yourRisk")
              }}<span
                :class="`severity-name ${
                  value.severity == 3
                    ? 'high'
                    : value.severity == 2
                    ? 'moderate'
                    : 'low'
                }`"
                >{{ value.severityName }}</span
              >{{ $t("compareWithNormal") }}
            </p>
          </div>

          <div v-if="value.showSuggestion" class="show-suggestion">
            <p class="suggestion-header">{{ $t("suggestHeader") }}</p>
            <div class="suggestion-detail">
              <div v-for="item in value.suggest" :key="item.id">
                <ul>
                  <li>{{ item }}</li>
                </ul>
              </div>
            </div>
            <div class="note-detail">
              <div>
                <p>{{ value.note }}</p>
              </div>
            </div>
          </div>

          <div
            class="see-suggestion flex-mid"
            @click="value.showSuggestion = !value.showSuggestion"
          >
            <div v-if="!value.showSuggestion" class="more-suggestion flex-mid">
              <p>{{ $t("moreSuggestionButton") }}</p>
              <div style="margin-left: 0.5rem" class="flex-mid icon">
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2458 0.290792C10.0584 0.104542 9.80498 0 9.5408 0C9.27661 0 9.02316 0.104542 8.8358 0.290792L5.2458 3.83079L1.7058 0.290792C1.51844 0.104542 1.26498 0 1.0008 0C0.736612 0 0.483161 0.104542 0.295798 0.290792C0.20207 0.383755 0.127675 0.494356 0.0769067 0.616216C0.026138 0.738075 0 0.868781 0 1.00079C0 1.1328 0.026138 1.26351 0.0769067 1.38537C0.127675 1.50723 0.20207 1.61783 0.295798 1.71079L4.5358 5.95079C4.62876 6.04452 4.73936 6.11891 4.86122 6.16968C4.98308 6.22045 5.11379 6.24659 5.2458 6.24659C5.37781 6.24659 5.50852 6.22045 5.63037 6.16968C5.75223 6.11891 5.86283 6.04452 5.9558 5.95079L10.2458 1.71079C10.3395 1.61783 10.4139 1.50723 10.4647 1.38537C10.5155 1.26351 10.5416 1.1328 10.5416 1.00079C10.5416 0.868781 10.5155 0.738075 10.4647 0.616216C10.4139 0.494356 10.3395 0.383755 10.2458 0.290792Z"
                    fill="#28500B"
                  />
                </svg>
              </div>
            </div>
            <div v-else class="more-suggestion flex-mid">
              <p>{{ $t("seeLess") }}</p>
              <div style="margin-left: 0.5rem" class="flex-mid icon">
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.295218 5.95579C0.48258 6.14204 0.736032 6.24658 1.00022 6.24658C1.2644 6.24658 1.51785 6.14204 1.70522 5.95579L5.29522 2.41579L8.83522 5.95579C9.02258 6.14204 9.27603 6.24658 9.54022 6.24658C9.8044 6.24658 10.0579 6.14204 10.2452 5.95579C10.3389 5.86283 10.4133 5.75223 10.4641 5.63037C10.5149 5.50851 10.541 5.3778 10.541 5.24579C10.541 5.11378 10.5149 4.98307 10.4641 4.86121C10.4133 4.73935 10.3389 4.62875 10.2452 4.53579L6.00522 0.295789C5.91225 0.202061 5.80165 0.127667 5.67979 0.0768981C5.55794 0.0261293 5.42723 -9.03013e-06 5.29522 -9.04167e-06C5.16321 -9.05321e-06 5.0325 0.0261292 4.91064 0.0768981C4.78878 0.127667 4.67818 0.202061 4.58522 0.295789L0.295218 4.53579C0.20149 4.62875 0.127095 4.73935 0.0763265 4.86121C0.0255576 4.98307 -0.000581642 5.11378 -0.000581654 5.24579C-0.000581665 5.3778 0.0255576 5.50851 0.0763264 5.63037C0.127095 5.75222 0.201489 5.86283 0.295218 5.95579Z"
                    fill="#28500B"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="age > 45" class="mt-10 fs-12">
        <div>{{ $t("suggest50y") }}</div>
      </div>
      <!-- <div v-if="age >=19&&age<50" class="mt-10 fs-12">
      <div v-html="$t('nothaverisksuggest2')"></div>
    </div> -->
      <div class="mt-20" v-if="riskData.length < 3 && riskData.length != 0">
        {{ $t("suggestedisease2") }}
      </div>

      <!-- <div @click="$router.push('/home')" style="width: 25rem" id="goToHome"
      class="btn-48 btn-primary2 btn mx-auto mt-15 mb-32">
      {{ $t("gotohome") }}
    </div> -->
    </div>
    <div class="bottom-nav">
      <div
        @click="$router.push('/show-all-package')"
        class="btn-48 btn-bundlepack btn mx-auto mt-22"
        id="buttonYourHealthPackage"
        style="width: 25rem; font-size: 1.6rem; font-weight: 400"
      >
        {{ $t("yourPersonalizePackage") }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import axios from "axios";
export default defineComponent({
  name: "AssessmentReport",
  data() {
    return {
      lang: "th",
      is19To50: false,
      accessToken: null,
      channel: null,
      isLoading: true,
      age: null,
      riskData: [],
      showSuggestion: false,
      reportData: [
        {
          title: "Risk of Achilles Tendon Injury",
          id: "te-st-one-data-001",
          status: "moderate",
        },
        {
          title: "Oxygen/Vo  Efficiency",
          id: "te-st-one-data-002",
          status: "very-high",
        },
        {
          title: "Exercise Associated Muscle Cramps",
          id: "te-st-one-data-003",
          status: "low",
        },
      ],
    };
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.getData();
    this.getCustomer();
  },
  methods: {
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/health-assessment/calculate",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          let riskSeverity = [];
          // riskScore
          const riskScore = res.risks;
          for (let i = 0; i < riskScore.length; i++) {
            if (riskScore[i].severity > 0) {
              riskSeverity.push(riskScore[i]);
            }
          }
          riskSeverity.sort((a, b) => b.severity - a.severity);
          // riskSeverity["suggest"] = riskSeverity.riskRecommendation
          //         .replace(/^[ ]*-/g, "")
          //         .split("\n-");

          for (let item in riskSeverity) {
            if (riskSeverity[item].riskRecommendation.match(/\*.+/g)) {
              riskSeverity[item]["note"] = riskSeverity[item].riskRecommendation
                .match(/\*.+/g)
                .toString();

              riskSeverity[item].riskRecommendation = riskSeverity[
                item
              ].riskRecommendation.replace(/\*.+/g, "");
            } else {
              let index = riskSeverity[item].riskRecommendation.match("Note");
              riskSeverity[item]["note"] = riskSeverity[
                item
              ].riskRecommendation.substring(index.index);
              riskSeverity[item].riskRecommendation = riskSeverity[
                item
              ].riskRecommendation.substring(0, index.index);
              // riskSeverity[item].riskRecommendation = riskSeverity[
              //   item
              // ].riskRecommendation.replace(/\*.+/g, "");

              // riskSeverity[item]["note"] =
              //   riskSeverity[item].riskRecommendation;
            }
            riskSeverity[item]["suggest"] = riskSeverity[
              item
            ].riskRecommendation
              .replace(/^[ ]*-/g, "")
              .split("\n-");
            riskSeverity[item]["showSuggestion"] = false;
          }

          this.riskData = riskSeverity;
          this.isLoading = false;
        });
      // .catch((error) => {
      //   // this.loadingStatus = false;
      //   if (error.response.status == 403) {
      //     this.getNewToken();
      //   } else {
      //     this.loadingStatus = false;
      //     this.error = error;
      //   }
      // });
    },
    getCustomer() {
      // this.loadingStatus = true;
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/get",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          var today = new Date();
          var year = today.getFullYear();
          var yearData = res.data.customer.birthDate;
          var birthDate = new Date(yearData);
          var birthyear = birthDate.getFullYear();
          this.age = year - birthyear;
          const customer = res.data.customer;
          let age = new Date(customer.birthDate);
          let now = new Date();
          if (
            now.getFullYear() - age.getFullYear() >= 19 &&
            now.getFullYear() - age.getFullYear() <= 50
          ) {
            this.is19To50 = true;
          }
        })
        .catch((error) => {
          // this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
          } else {
            this.loadingStatus = false;
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
  },
});
</script>

<style lang="scss" scoped>
.assessment-report {
  margin: auto;
  width: calc(100%);
  max-width: 450px;
  padding: 0 1.5rem;
  padding-bottom: 10rem;

  .report-card {
    // padding: 1.8rem;
    width: 100%;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
    border-radius: 20px;

    .card-header {
      background: #ffffff;
      display: inline-flex;
      width: 80%;
      margin: 1rem 1.8rem 1rem 1.8rem;
      padding-top: 2rem;
      line-height: 4rem;

      .icon {
        .icon-background {
          background: #f2f6ff;
          width: 4rem;
          height: 4rem;
          border-radius: 15px;
        }

        .icon-background.cardiovascular {
          background: #f2f6ff;
          width: 4rem;
          height: 4rem;
          border-radius: 15px;
        }

        .icon-background.metabolic-syndrome {
          background: #ebfbec;
          width: 4rem;
          height: 4rem;
          border-radius: 15px;
        }

        .icon-background.diabetes {
          background: #f2fada;
          width: 4rem;
          height: 4rem;
          border-radius: 15px;
        }

        .icon-background.colon-cancer {
          background: #f5f3e2;
          width: 4rem;
          height: 4rem;
          border-radius: 15px;
        }

        .icon-background.stroke {
          background: #eef8fa;
          width: 4rem;
          height: 4rem;
          border-radius: 15px;
        }

        .icon-background.lung-cancer {
          background: #fcf0e8;
          width: 4rem;
          height: 4rem;
          border-radius: 15px;
        }
      }

      .risk-name {
        font-size: 16px;
        font-weight: 500;
        line-height: 4rem;
        letter-spacing: 0em;
        text-align: left;
        margin-left: 1rem;
      }
    }

    .risklevel {
      img {
        // object-fit: scale-down;
        object-fit: cover;
        width: 25rem;
      }
    }

    .card-description {
      margin: 0rem 0rem 1rem 0rem;

      .your-risk-assessment {
        font-size: 1.4rem;
        font-weight: 400;
        color: #545454;
        margin: 0;

        .severity-name {
          font-size: 1.4rem;
          font-weight: 400;
        }

        .severity-name.high {
          color: #f0554c;
        }

        .severity-name.moderate {
          color: #ddb21c;
        }

        .severity-name.low {
          color: #4ab848;
        }
      }
    }

    .show-suggestion {
      margin: 2rem;
      text-align: left;

      .suggestion-header {
        color: #545454;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
      }

      .suggestion-detail {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
      }
      .note-detail {
        margin-left: 1rem;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
      }
    }

    .see-suggestion {
      display: flex;
      background: #ecf5ca;
      border-radius: 0px 0px 20px 20px;
      // width: 100%;
      height: 4rem;
      // padding: 1rem;
      margin: auto;

      .more-suggestion {
        text-decoration: underline;
        margin: auto;
        font-size: 14px;
        font-weight: 400;
        color: #28500b;
        line-height: 4rem;

        .icon {
          margin-top: -1rem;
        }
      }
    }
  }

  .no-suggest-package {
    background: #fff;
    border-radius: 15px;
    width: calc(100% - 1rem);
    max-width: calc(400px + 4rem);
    margin: 0rem auto;
    padding: 5px;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
    // height: 8rem;
    font-size: 12px;
  }
}

.bottom-nav {
  bottom: 0;
  position: fixed;
  background: #ffffff;
  width: 100%;
  padding: 1rem 0;

  .btn-bundlepack {
    background-color: #d2e97a;
    color: #000000;
    font-weight: 500;
    margin: auto;

    &:hover {
      background-color: #d2e97a;
    }
  }
}

.loading-page {
  .description {
    .header {
      color: #000000;
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
      letter-spacing: 0em;
    }

    .detail {
      color: #1f2022;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.20000000298023224px;
      text-align: center;
    }
  }
}
</style>
